import { make } from 'vuex-pathify'

const state = {
    display: false,
    content: null,
    color: 'primary',
}

const actions = {
    display({ commit }, { content, color }) {
        commit('SET_COLOR', color)
        commit('SET_CONTENT', content)
        commit('SET_DISPLAY', true)
    },

    warn({ dispatch }, content) {
        dispatch('display', {
            content,
            color: 'warning'
        })
    },

    error({ dispatch }, content) {
        dispatch('display', {
            content,
            color: 'error'
        })
    },

    genericError({ dispatch }) {
        dispatch('error', 'Terjadi kesalahan, coba lagi')
    },

    info({ dispatch }, content) {
        dispatch('display', {
            content,
            color: 'info'
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations: make.mutations(state),
    actions
}
